import Vue from 'vue'
import Router from 'vue-router'

const PostTypes = window.WPVUE.post_types

const WPVUE = window.WPVUE;
import frontPage from './views/Home.vue'
import singlePage from './views/SinglePage.vue'
import singlePost from './views/SinglePost.vue'
import singleProject from './views/SingleProject.vue'
import singleService from './views/SingleService.vue'
import singleMachine from './views/SingleMachine.vue'
import archive from './views/Archive.vue'

Vue.use(Router)

export default new Router({
  mode: "history",

  //base: process.env.BASE_URL,
  routes: [


    {
      path: '/',
      name: 'frontPage',
      component: frontPage,
      meta: { post_type: 'page', type: 'frontPage', title: 'Hjem', id: window.WPVUE.front_page }
    },


    {
      path: '/' + WPVUE.post_page_slug,
      name: 'archivePost',
      component: archive,
      meta: { post_type: 'post', type: 'archive', title: 'Archive post' }
    },
    {
      path: '/' + WPVUE.post_page_slug + '/:name',
      name: 'singlePost',
      component: singlePost,
      meta: { post_type: 'post', type: 'single', title: 'Single post', archive: '/' + WPVUE.post_page_slug }
    },


    {
      path: '/' + WPVUE.archives.projects.slug,
      name: 'archiveProjects',
      component: archive,
      meta: { post_type: 'projects', type: 'archive', title: 'Archive projects' }
    },
    {
      path: '/' + WPVUE.archives.projects.slug + '/:name',
      name: 'singleProject',
      component: singleProject,
      meta: { post_type: 'projects', type: 'single', title: 'Single project', archive: '/' + WPVUE.archives.projects.slug }
    },

    {
      path: '/' + WPVUE.archives.services.slug,
      name: 'archiveServices',
      component: archive,
      meta: { post_type: 'services', type: 'archive', title: 'Archive services' }
    },
    {
      path: '/' + WPVUE.archives.services.slug + '/:name',
      name: 'singleService',
      component: singleService,
      meta: { post_type: 'services', type: 'single', title: 'Single service', archive: '/' + WPVUE.archives.services.slug }
    },

    {
      path: '/' + WPVUE.archives.machines.slug,
      name: 'archiveMachines',
      component: archive,
      meta: { post_type: 'machines', type: 'archive', title: 'Archive machines' }
    },
    {
      path: '/' + WPVUE.archives.machines.slug + '/:name',
      name: 'singleMachine',
      component: singleMachine,
      meta: { post_type: 'machines', type: 'single', title: 'Single machines', archive: '/' + WPVUE.archives.machines.slug }
    },


    // Standard Pages
    {
      path: '/:name',
      name: 'singlePage',
      component: singlePage,
      meta: { post_type: 'page', type: 'single', title: 'Single page' }
    },

  ],

  scrollBehavior(to, from, savedPosition) {
    if (window.location.search) {
      const hash = location.search.substring(1);
      const el = document.getElementById(hash);
      //if (el) $('html, body').animate({ scrollTop: el.offsetTop + 20 }, 450);
    } else {
      return { x: 0, y: 0 }
    }
  },

})
